import React, { useContext, useEffect } from 'react';
import {
	ICreateModifierGroupsContext,
	CreateModifierGroupsContext,
} from '../../createModifierGroupsState/createModifierGroupsContext';
import CreationForm from './components/CreationForm/CreationForm';
import TranslationsForm from './components/TranslationsForm';
import style from './Forms.module.scss';

const Forms: React.FC = () => {
	const { visibleForm } = useContext<ICreateModifierGroupsContext>(CreateModifierGroupsContext);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [visibleForm]);

	return (
		<div className={style.container} data-test="Forms">
			<CreationForm isVisible={visibleForm === 'mainForm'} />
			<TranslationsForm isVisible={visibleForm === 'translations'} />
		</div>
	);
};

export default Forms;
